import React from 'react';
import { ListItem, ListItemIcon, Typography } from '@mui/material';
import ChipIcon from './ChipIcon';

const ChipListItem = ({children}) => (
	<ListItem>
		<ListItemIcon>
			<ChipIcon/>
		</ListItemIcon>
		<Typography variant="body1">
			{children}
		</Typography>
	</ListItem>
);

export default ChipListItem;
